module.exports = __webpack_public_path__ + "static/media/default-my-account-img.64c19173.png";